// eslint-disable-next-line no-shadow
export enum ELocations {
  NORTH_AMERICA = 'NORTH_AMERICA',
  EUROPE = 'EUROPE',
  MIDDLE_EAST = 'MIDDLE_EAST',
}

export interface User {
  id: string;
  fullName: string;
  phone: string;
}

export interface LoginUserPayload {
  token: string;
  user: User;
}

export interface IPermissions {
  ACCESS_VEHICLES_PAGE: boolean;
  ACCESS_INVENTORY_PAGE: boolean;
  ACCESS_ACTIONS_BUTTON: boolean;
  ACCESS_ASSIGNMENT_PAGE: boolean;
  PERFORM_VEHICLE_ASSIGNMENT_REQUEST_APPROVAL: boolean;
  PERFORM_APPROVE_REJECT_VEHICLE_ASSIGNMENT_REQUEST: boolean;
  PERFORM_CANCEL_ORDERS: boolean;
  PERFORM_RELEASE_ORDERS_TO_INVENTORY: boolean;
  VIEW_BUILD_SLOTS: boolean;
  PERFORM_DIRECT_APPROVE_ASSIGNMENT: boolean;
  PERFORM_LIMITED_DIRECT_ASSIGNMENT: boolean;
  PERFORM_REQUEST_ONLY: boolean;
  CHANGE_ASSIGNMENT_ACTION: boolean;
  role: string;
  ACCESS_WHEEL_SWAP_OPTIONS: boolean;
  locationPermission: string[];
}

export type IAvailablePermissions = keyof IPermissions;
